// extracted by mini-css-extract-plugin
export default {"genericCard":"Jm-z","inline":"Km-z","mastercard":"Lm-z","discover":"Mm-z","visa":"Nm-z","amex":"Om-z","active":"Pm-z"};